module.exports = __webpack_public_path__ + "img/icon-pharma.63b2b27a.svg";